<template>
  <div>
    历史成绩查询
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
